// @flow
/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { Radio, RadioGroup } from '@zapier/design-system';

const Styles = {
  root: css`
    display: flex;
  `,
};

type Props = {
  field?: {
    key: string,
    label: string,
    value: string,
    choices: Array<{ value: string, label: string }>,
    readOnly?: boolean,
  },
  value?: string,
  choices: Array<{ value: string, label: string }>,
  onChange: (value: string, props: {}) => void,
  readOnly?: boolean,
};

const RadioArray = (props: Props) => {
  const source = props.field || props;

  return (
    <RadioGroup
      css={Styles.root}
      aria-label={source.label || source.key || 'type'}
      value={source.value}
      onChange={value => {
        props.onChange(value, { field: source });
      }}
      isDisabled={source.readOnly}
      orientation="horizontal"
    >
      {source.choices.map(choice => (
        <Radio key={choice.value} value={choice.value}>
          {choice.label}
        </Radio>
      ))}
    </RadioGroup>
  );
};

RadioArray.defaultProps = {
  choices: [],
};

export default RadioArray;
